module.exports = __webpack_public_path__ + "static/media/SocialLogos_youtube.c2caa05e.svg";